import axios from 'axios';
import {useTranslation} from 'react-i18next';
import {useLoaderData} from 'react-router-dom';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {IDynamismCategory} from './DynamismInterface';
import {appConfig} from '@config';
import React from 'react';
import CustomCard from '@components/uikit/Card';


export default function Dynamisms() {
	const categories = useLoaderData() as IDynamismCategory[];
	const {t} = useTranslation();
	return (
		<>
			<HeaderWithIcons title={t('dynamism.title')}/>
			<div className="flex flex-col space-y-2 px-4">
				{
					categories ?
						categories.map(category => <CustomCard
							key={category.id}
							title={category.name}
							image={category.image}
							url={`/dynamism/${category.id}`}
							state={category}/>
						) : ''
				}
			</div>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function dynamismCategoriesLoader(data: loader) {
	const res = await axios({
		url: `${appConfig.dynamisms.url}categories`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
